import React from 'react'
import {Flex, Modal} from '/app/src/component';

//DEPRECATED, USE UPGRADE MODAL

class TryProModal extends React.Component {
    render(){
        const { open, onClose, title, body, header} = this.props

        return (
            <Modal
                title={header}
                open={open}
                onClose={onClose}>
            <Flex column w='100%' hAlignContent='center' my='25px' center>
                <Flex color='#404040' fontSize='24px' fontWeight='500'>
                    {title}
                </Flex>
                <Flex color='#404040' textAlign='center' fontSize='20px' paddingLeft='20px' paddingRight='20px' mt='10px' fontWeight='300' center>
                </Flex>
                <Flex row padding='50px'>
                    {body}
                </Flex>
            </Flex>
            </Modal>
        )
    }
}

export default TryProModal;



// WEBPACK FOOTER //
// ./src/component/Modal/TryProModal/index.js